
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 3.886L9.511 1.58A1.983 1.983 0 008.093 1l-2.849.025a1.979 1.979 0 00-1.384.58L1.58 3.886c-.371.371-.58.875-.58 1.401V8.1c0 .526.209 1.03.58 1.401l2.92 3m12-4l1.915 1.988a2 2 0 010 2.83l-5.094 5.096a2 2 0 01-2.83 0L8.5 16.5M6.313 5.759a.389.389 0 11-.55.55.389.389 0 01.55-.55zM3 18L18 2","stroke":"#494949","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    